/* caret-fix-20260917-2300 */

(function(){
  var WA = null;
  function cartRoot(){
    return document.querySelector('#ihp-cart-host .tt-cart') || document.querySelector('.tt-cart');
  }
  function ensureBackdrop(){
    var el=document.querySelector('.iron-cart-drawer-backdrop');
    if(!el){
      el=document.createElement('div');
      el.className='iron-cart-drawer-backdrop';
      document.body.appendChild(el);
      el.addEventListener('click', function(e){ e.preventDefault(); closeIronCart(); });
    }
    return el;
  }
  function closeIronCart(){
    var root=cartRoot();
    if(root){ root.classList.remove('active','activetoview'); }
    var panel=root && root.querySelector('.tt-dropdown-menu.iron-cart-drawer');
    if(panel){ panel.style.setProperty('display','none','important'); }
    document.body.classList.remove('iron-cart-drawer-open','tt-popup-dropdown');
    document.documentElement.classList.remove('iron-cart-drawer-open');
    var bd=document.querySelector('.iron-cart-drawer-backdrop');
    if(bd){ bd.classList.remove('is-visible','active'); bd.style.setProperty('display','none','important'); }
  }
  function openIronCart(e){
    if(e){ e.preventDefault(); e.stopPropagation(); e.stopImmediatePropagation(); }
    var host=document.getElementById('ihp-cart-host');
    if(host && host.parentElement!==document.body){ document.body.appendChild(host); }
    if(host){
      host.style.setProperty('z-index','100000','important');
      host.style.setProperty('position','fixed','important');
      host.style.setProperty('pointer-events','none','important');
    }
    var root=cartRoot();
    var panel=root && root.querySelector('.tt-dropdown-menu.iron-cart-drawer');
    if(!root || !panel){ console.warn('[iron-header] cart missing'); return false; }
    root.classList.add('active','activetoview');
    panel.style.setProperty('display','block','important');
    panel.style.setProperty('visibility','visible','important');
    panel.style.setProperty('opacity','1','important');
    panel.style.setProperty('pointer-events','auto','important');
    panel.style.setProperty('z-index','100010','important');
    panel.style.setProperty('position','fixed','important');
    panel.style.setProperty('background','#1a1a1a','important');
    panel.style.setProperty('filter','none','important');
    document.body.classList.add('iron-cart-drawer-open');
    document.documentElement.classList.add('iron-cart-drawer-open');
    var bd=ensureBackdrop();
    if(bd.parentElement!==document.body) document.body.appendChild(bd);
    bd.classList.add('is-visible','active');
    bd.style.setProperty('display','block','important');
    bd.style.setProperty('z-index','99990','important');
    if(host) document.body.appendChild(host);
    return false;
  }
  window.ihpOpenCart=openIronCart;
  window.ihpCloseCart=closeIronCart;

  document.addEventListener('click', function(e){
    var a=e.target.closest && e.target.closest('[data-ihp-cart]');
    if(a){ openIronCart(e); return; }
    var btn=e.target.closest && e.target.closest('.iron-cart-drawer__close');
    if(btn){ e.preventDefault(); e.stopPropagation(); closeIronCart(); }
  }, true);
  document.addEventListener('keydown', function(e){ if(e.key==='Escape') closeIronCart(); });

  function killWokieeChrome(){
    if(document.body.classList.contains('iron-cart-drawer-open')) return;
    var sels=[
      '#shopify-section-header-template-2','.tt-top-panel','.tt-mobile-header','.tt-stuck-nav',
      'header.desctop-menu-large','header.headertype2','#shopify-section-promo-fixed'
    ];
    sels.forEach(function(sel){
      document.querySelectorAll(sel).forEach(function(el){
        if(el.closest && (el.closest('#ihp-cart-host') || el.closest('#iron-site-header'))) return;
        el.style.setProperty('display','none','important');
        el.style.setProperty('visibility','hidden','important');
        el.style.setProperty('height','0','important');
        el.style.setProperty('max-height','0','important');
        el.style.setProperty('overflow','hidden','important');
        el.style.setProperty('opacity','0','important');
      });
    });
  }
  killWokieeChrome();
  document.addEventListener('DOMContentLoaded', killWokieeChrome);
  window.addEventListener('load', killWokieeChrome);
  setInterval(killWokieeChrome, 3000);



  function syncCartBadge(n){
    if(typeof n!=='number'){
      var b=document.querySelector('#ihp-cart-host .tt-badge-cart');
      if(b){ n=parseInt((b.textContent||'0').replace(/\D/g,''),10)||0; }
      else n=0;
    }
    document.querySelectorAll('[data-ihp-cart-badge]').forEach(function(el){
      el.textContent=String(n);
      el.classList.toggle('is-empty', !n);
    });
  }
  window.ihpSyncCartBadge=syncCartBadge;
  document.addEventListener('cart:updated', function(){ setTimeout(syncCartBadge, 50); });
  document.addEventListener('DOMContentLoaded', function(){ syncCartBadge(); });
  // Observe Wokiee badge in host
  document.addEventListener('DOMContentLoaded', function(){
    var host=document.getElementById('ihp-cart-host');
    if(!host) return;
    var obs=new MutationObserver(function(){ syncCartBadge(); });
    obs.observe(host,{subtree:true,childList:true,characterData:true});
  });







  // Mobile accordion: one open; caret via CSS ▾/▴
  function ihpIsMobile(){ return window.matchMedia('(max-width:900px)').matches; }
  function ihpCloseAllDds(){
    document.querySelectorAll('#ihp-nav .ihp-dd.is-open').forEach(function(dd){
      dd.classList.remove('is-open');
      var t=dd.querySelector(':scope > a');
      if(t) t.setAttribute('aria-expanded','false');
    });
  }
  function ihpSyncCarets(){ /* CSS-driven via .is-open */ }
  document.addEventListener('click', function(e){
    if(!ihpIsMobile()) return;
    // Ignore clicks inside open mega panel links/cards
    if(e.target.closest && e.target.closest('#ihp-nav .ihp-mega, #ihp-nav .ihp-ff-mega, #ihp-nav .ihp-dd-panel a.ihp-mega-card')) return;
    var a=e.target.closest && e.target.closest('#ihp-nav .ihp-dd > a');
    if(!a) return;
    e.preventDefault();
    e.stopPropagation();
    var dd=a.parentElement;
    var willOpen=!dd.classList.contains('is-open');
    ihpCloseAllDds();
    if(willOpen){
      dd.classList.add('is-open');
      a.setAttribute('aria-expanded','true');
    }
    ihpSyncCarets();
  }, true);
  document.addEventListener('click', function(e){
    var btn=e.target.closest && e.target.closest('.ihp-menu-btn');
    if(!btn) return;
    setTimeout(ihpCloseAllDds, 0);
  });
  document.addEventListener('DOMContentLoaded', function(){
    if(ihpIsMobile()) ihpCloseAllDds();
    document.querySelectorAll('#ihp-nav .ihp-dd > a').forEach(function(a){
      if(!a.hasAttribute('aria-expanded')) a.setAttribute('aria-expanded','false');
    });
  });
  try{
    window.matchMedia('(max-width:900px)').addEventListener('change', function(ev){
      if(ev.matches) ihpCloseAllDds();
    });
  }catch(_e){}

  // Desktop megas: keep-open delay (~180ms) so diagonal move trigger→panel
  // doesn't dismiss. CSS :hover + .is-open; bridge covers physical gap.
  // Applies to ALL .ihp-dd--mega (and legacy .ihp-dd--ff).
  (function initMegaDesktopHover(){
    var dds=document.querySelectorAll('#ihp-nav .ihp-dd--mega, #ihp-nav .ihp-dd--ff');
    if(!dds.length) return;
    var CLOSE_MS=180;
    function isDesktop(){ return window.matchMedia('(min-width:901px)').matches; }
    dds.forEach(function(dd){
      var closeTimer=null;
      function openMega(){
        if(closeTimer){ clearTimeout(closeTimer); closeTimer=null; }
        // Close sibling megas so only one stays open
        dds.forEach(function(other){ if(other!==dd) other.classList.remove('is-open'); });
        dd.classList.add('is-open');
      }
      function scheduleClose(){
        if(closeTimer) clearTimeout(closeTimer);
        closeTimer=setTimeout(function(){
          dd.classList.remove('is-open');
          closeTimer=null;
        }, CLOSE_MS);
      }
      dd.addEventListener('mouseenter', function(){ if(isDesktop()) openMega(); });
      dd.addEventListener('mouseleave', function(){ if(isDesktop()) scheduleClose(); });
      dd.addEventListener('focusin', function(){ if(isDesktop()) openMega(); });
      dd.addEventListener('focusout', function(e){
        if(!isDesktop()) return;
        if(e.relatedTarget && dd.contains(e.relatedTarget)) return;
        scheduleClose();
      });
    });
  })();

})();
